export default __webpack_public_path__ + "static/media/Isoform-Mapper-Image.04f3f4b5.svg";